export default {
  path: '/lvy-moment-rule',
  component: () => import('./LVYMomentRule'),
  meta: {
    title: '社区内容发布规范',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
